export const cpus = undefined;